export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6924.ef8812f3.jpg";